import dayjs from 'dayjs';
import { localizeDate } from './localizeDate';

const formatDateStr = (dateStr, dateFormat: string, locale?: string) => {
  if (!dateStr) return '';
  if (locale) {
    return dayjs(dateStr).locale(locale).format(dateFormat);
  }
  return dayjs(dateStr).format(dateFormat);
};

// Format's date string using dayjs format
// Formatting options: https://day.js.org/docs/en/display/format
export const formatDate = {
  monthDayYearKebab: (dateStr) => formatDateStr(dateStr, localizeDate('MM-DD-YYYY')),
  monthDay: (dateStr) => formatDateStr(dateStr, localizeDate('MMMM DD')),
  monthDayYear: (dateStr) => formatDateStr(dateStr, localizeDate('MMMM DD, YYYY')),
  monthYear: (dateStr) => formatDateStr(dateStr, localizeDate('MMMM YYYY')),
  monthYearEN: (dateStr) => formatDateStr(dateStr, 'MMMM YYYY', 'en'),
  time: (dateStr) => formatDateStr(dateStr, localizeDate('h:mm A')),
  year: (dateStr) => formatDateStr(dateStr, localizeDate('YYYY')),
  yearMonth: (dateStr) => formatDateStr(dateStr, localizeDate('YYYYMM')),
  yearMonthDay: (dateStr) => formatDateStr(dateStr, localizeDate('YYYYMMDD')),
};
